module.exports = __webpack_public_path__ + "static/media/view2.7c4e54f0.jpg";